exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3NMyY{display:flex;border-radius:5px;overflow:hidden}._36aAX{background:rgba(255,255,255,0.8);color:black;padding:18px 20px;cursor:pointer}._36aAX:not(:last-child){border-right:1px solid #f27052}._36aAX:hover,._36aAX._2rmay{background:white}._2JvZg{font-size:14px;margin-top:20px}._2JvZg a{cursor:pointer;opacity:0.8}._2JvZg a:hover{opacity:1}\n", ""]);

// Exports
exports.locals = {
	"buttons": "_3NMyY",
	"button": "_36aAX",
	"selected": "_2rmay",
	"positioning": "_2JvZg"
};